import { useLocation } from 'react-router-dom';
import SeoHead from './SeoHead';
import { getStaticPageMeta } from './pageMeta';
import { buildCalculatorJsonLd } from './structuredData';
import { buildCanonicalUrl } from './siteConfig';

/** Sets meta tags for static routes. Dynamic pages override via their own SeoHead. */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const meta = getStaticPageMeta(pathname);

  if (!meta) return null;

  const jsonLd = pathname.startsWith('/calculator/') ? buildCalculatorJsonLd(pathname) : undefined;

  return (
    <SeoHead
      title={meta.title}
      description={meta.description}
      url={buildCanonicalUrl(pathname)}
      noindex={Boolean(meta.noindex)}
      jsonLd={jsonLd}
    />
  );
}
